'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _IndexControl = require('../../../lib/ui/IndexControl');

var _IndexControl2 = _interopRequireDefault(_IndexControl);

var _PersonForm = require('../ui/PersonForm');

var _PersonForm2 = _interopRequireDefault(_PersonForm);

var _PersonModel = require('../model/PersonModel');

var _PersonModel2 = _interopRequireDefault(_PersonModel);

var _OrganisationModel = require('../../organisation/model/OrganisationModel');

var _OrganisationModel2 = _interopRequireDefault(_OrganisationModel);

var _PositionModel = require('../../position/model/PositionModel');

var _PositionModel2 = _interopRequireDefault(_PositionModel);

var _EducationModel = require('../../education/model/EducationModel');

var _EducationModel2 = _interopRequireDefault(_EducationModel);

var _LogentryModel = require('../../logentry/model/LogentryModel');

var _LogentryModel2 = _interopRequireDefault(_LogentryModel);

var _LocationModel = require('../../location/model/LocationModel');

var _LocationModel2 = _interopRequireDefault(_LocationModel);

var _RelationshipModel = require('../../relationship/model/RelationshipModel');

var _RelationshipModel2 = _interopRequireDefault(_RelationshipModel);

var _ObjectTypeMapping = require('../../constants/ObjectTypeMapping');

var _ObjectTypeMapping2 = _interopRequireDefault(_ObjectTypeMapping);

var _VcardExporter = require('../exporters/VcardExporter');

var _VcardExporter2 = _interopRequireDefault(_VcardExporter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditPerson = function EditPerson(element, args) {
  var _this = this;

  _classCallCheck(this, EditPerson);

  this.onchange = function () {
    _this.data = _this.personForm.getValue();
    window.PRIM.initDelayedNavigation();
    window.PRIM.dataAccess.put('people', _this.data.getJSON()).then(function (person) {
      if (!window.PRIM.isDelayedNavigationActive()) {
        return;
      }

      if (args && !args.id && person.id) {
        window.PRIM.navigate('/people/' + person.id, true);
      }

      if (person) {
        _this.data.values.id = person.id;
        _this.personForm.setValue(_this.data);
      }
    }).catch(window.PRIM.exceptionHandler);
  };

  if (args && args.id) {
    window.PRIM.dataAccess.resolve('people', args.id, true).then(function (person) {
      _this.data = person;
      _this.personForm.setValue(_this.data);

      window.PRIM.dataAccess.get('relationships').then(function (relationships) {
        var results = relationships.filter(function (relationship) {
          return relationship.person_id === _this.data.values.id;
        });

        var promisesToResolve = 0;
        _this.data.relationships = results.map(function (relationship) {
          var model = new _RelationshipModel2.default(relationship);
          model.person = _this.data;
          if (relationship.target_id) {
            promisesToResolve++;
            window.PRIM.dataAccess.get('people', relationship.target_id).then(function (target) {
              model.target = new _PersonModel2.default(target);
              promisesToResolve--;
              if (promisesToResolve === 0) {
                _this.relationshipIndex.setItems(_this.data.relationships);
              }
            }).catch(function (e) {
              promisesToResolve--;
              window.PRIM.exceptionHandler(e);
            });
          }

          return model;
        });

        if (promisesToResolve === 0) {
          _this.relationshipIndex.setItems(_this.data.relationships);
        }
      }, function () {}).catch(window.PRIM.exceptionHandler);
      window.PRIM.dataAccess.get('positions').then(function (positions) {
        var results = positions.filter(function (position) {
          return position.person_id === _this.data.values.id;
        });

        _this.data.positions = results.map(function (position) {
          var model = new _PositionModel2.default(position);
          model.person = _this.data;
          if (position.location_id) {
            window.PRIM.dataAccess.get('locations', position.location_id).then(function (location) {
              model.location = new _LocationModel2.default(location);
              if (location.organisation_id) {
                window.PRIM.dataAccess.get('organisations', location.organisation_id).then(function (organisation) {
                  model.location.organisation = new _OrganisationModel2.default(organisation);
                  _this.positionIndex.setItems(_this.data.positions);
                }).catch(window.PRIM.exceptionHandler);
              } else {
                _this.positionIndex.setItems(_this.data.positions);
              }
            }).catch(window.PRIM.exceptionHandler);
          }

          return model;
        });

        _this.positionIndex.setItems(_this.data.positions);
      }, function () {}).catch(window.PRIM.exceptionHandler);
      window.PRIM.dataAccess.get('educations').then(function (educations) {
        var results = educations.filter(function (education) {
          return education.person_id === _this.data.values.id;
        });

        _this.data.educations = results.map(function (education) {
          var model = new _EducationModel2.default(education);

          if (education.location_id) {
            window.PRIM.dataAccess.get('locations', education.location_id).then(function (location) {
              model.location = new _LocationModel2.default(location);
              if (location.organisation_id) {
                window.PRIM.dataAccess.get('organisations', location.organisation_id).then(function (organisation) {
                  model.location.organisation = new _OrganisationModel2.default(organisation);
                  _this.educationIndex.setItems(_this.data.educations);
                }).catch(window.PRIM.exceptionHandler);
              } else {
                _this.educationIndex.setItems(_this.data.educations);
              }
            }).catch(window.PRIM.exceptionHandler);
          }

          return model;
        });

        _this.educationIndex.setItems(_this.data.educations);
      }, function () {}).catch(window.PRIM.exceptionHandler);
      window.PRIM.dataAccess.get('logentries').then(function (logentries) {
        var results = logentries.filter(function (logentry) {
          return logentry.target_id === _this.data.values.id && logentry.object_type_id === _ObjectTypeMapping2.default.person;
        });

        _this.data.logentries = results.map(function (logentry) {
          return new _LogentryModel2.default(logentry);
        });

        _this.logIndex.setItems(_this.data.logentries);
      }, function () {}).catch(window.PRIM.exceptionHandler);
    }, function () {
      if (confirm('Deze persoon bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuw persoon aanmaken?')) {
        window.PRIM.navigate('/people/');
      } else {
        history.back();
      }
    }).catch(window.PRIM.exceptionHandler);
  }

  this.data = new _PersonModel2.default();

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Persoon bewerken',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }, {
      onclick: function onclick() {
        history.forward();
      },
      icon: '\uE01A'
    }, {
      onclick: function onclick() {
        window.PRIM.navigate('/start/');
      },
      icon: '\uE08A'
    }, {
      onclick: this.onchange,
      icon: '\uE020',
      classes: 'indicator'
    }],
    contextMenu: [{
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/relationships/new/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze persoon.');
        }
      },
      icon: '\uE083',
      label: 'Relatie'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/positions/person/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze persoon.');
        }
      },
      icon: '\uE034',
      label: 'Functie'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          window.PRIM.navigate('/logentries/person/' + _this.data.values.id);
        } else {
          alert('Vul eerst gegevens voor deze persoon.');
        }
      },
      icon: '\uE032',
      label: 'Logboekregel'
    }, {
      onclick: function onclick() {
        if (_this.data.values.id) {
          if (confirm('Weet u het zeker dat u deze persoon wilt verwijderen?')) {
            window.PRIM.dataAccess.delete('people', _this.data.values.id).then(function () {
              history.back();
            });
          }
        } else {
          alert('Vul eerst gegevens voor deze persoon.');
        }
      },
      icon: '\uE123',
      label: 'Verwijderen'
    }, {
      onclick: function onclick() {
        var exporter = new _VcardExporter2.default();
        var model = _this.personForm.getValue();
        var vcard = exporter.export(model);
        var blob = new Blob([vcard], { type: 'text/vcard' });
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, 'export.vcf');
        } else {
          var url = URL.createObjectURL(blob);
          var tempAnchor = document.createElement('a');
          tempAnchor.href = url;
          tempAnchor.download = 'export.vcf';
          tempAnchor.className = 'invisible';
          document.body.appendChild(tempAnchor);
          tempAnchor.click();
          document.body.removeChild(tempAnchor);
          URL.revokeObjectURL(url);
        }
      },
      icon: '\uE052',
      label: 'Exporteren'
    }]
  });

  var div = document.createElement('div');
  div.className = 'viewport';

  var divContent = document.createElement('div');
  divContent.className = 'content';

  var primaryData = document.createElement('section');
  primaryData.className = 'primary';
  var secondaryData = document.createElement('section');
  secondaryData.className = 'secondary';

  this.personForm = new _PersonForm2.default(primaryData, { person: this.data, onchange: this.onchange });

  var fieldsetRelationships = document.createElement('fieldset');
  var legendRelationships = document.createElement('legend');
  legendRelationships.innerHTML = 'Relaties';
  fieldsetRelationships.appendChild(legendRelationships);

  var onclickRelationship = function onclickRelationship(item) {
    window.PRIM.navigate('/relationships/' + item.values.id);
    return;
  };

  this.relationshipIndex = new _IndexControl2.default(fieldsetRelationships, { items: this.data.relationships, onclick: onclickRelationship });

  secondaryData.appendChild(fieldsetRelationships);

  var fieldsetPositions = document.createElement('fieldset');
  var legendPositions = document.createElement('legend');
  legendPositions.innerHTML = 'Functies';
  fieldsetPositions.appendChild(legendPositions);

  var onclickPosition = function onclickPosition(item) {
    window.PRIM.navigate('/positions/' + item.values.id);
    return;
  };

  this.positionIndex = new _IndexControl2.default(fieldsetPositions, { items: this.data.positions, onclick: onclickPosition });

  secondaryData.appendChild(fieldsetPositions);

  var fieldsetEducations = document.createElement('fieldset');
  var legendEducations = document.createElement('legend');
  legendEducations.innerHTML = 'Opleidingen';
  fieldsetEducations.appendChild(legendEducations);

  var onclickEducation = function onclickEducation(item) {
    window.PRIM.navigate('/educations/' + item.values.id);
    return;
  };

  this.educationIndex = new _IndexControl2.default(fieldsetEducations, { items: this.data.educations, onclick: onclickEducation });

  secondaryData.appendChild(fieldsetEducations);

  var fieldsetLog = document.createElement('fieldset');
  var legendLog = document.createElement('legend');
  legendLog.innerHTML = 'Logboek';
  fieldsetLog.appendChild(legendLog);

  var onclickLogentry = function onclickLogentry(item) {
    window.PRIM.navigate('/logentries/' + item.values.id);
    return;
  };

  this.logIndex = new _IndexControl2.default(fieldsetLog, { items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry });

  secondaryData.appendChild(fieldsetLog);

  divContent.appendChild(primaryData);
  divContent.appendChild(secondaryData);
  div.appendChild(divContent);
  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = EditPerson;


//////////////////
// WEBPACK FOOTER
// ./js/modules/person/action/EditPerson.js
// module id = 32
// module chunks = 0